const tableV2NestedSkeletonFallbackRows = 3;
const tableV2NestedSkeletonMaxRows = 8;

export const resolveTableV2NestedSkeletonRowCount = (
  childCount: number | null | undefined,
): number => {
  if (childCount === null || childCount === undefined || !Number.isFinite(childCount)) {
    return tableV2NestedSkeletonFallbackRows;
  }

  return Math.min(tableV2NestedSkeletonMaxRows, Math.max(1, Math.ceil(childCount)));
};
